// Shared annotation drawing helpers for the coach response overlay.
export const ANNOTATION_WINDOW = 4; // seconds a drawing stays visible

export function drawShape(ctx, s, w, h) {
  ctx.strokeStyle = s.color || "#C9A227";
  ctx.lineWidth = Math.max(2, w * 0.004);
  ctx.lineCap = "round";
  if (s.type === "line") {
    ctx.beginPath();
    ctx.moveTo(s.x1 * w, s.y1 * h);
    ctx.lineTo(s.x2 * w, s.y2 * h);
    ctx.stroke();
  } else if (s.type === "circle") {
    ctx.beginPath();
    ctx.ellipse(s.cx * w, s.cy * h, Math.max(4, s.r * w), Math.max(4, s.r * w), 0, 0, 2 * Math.PI);
    ctx.stroke();
  }
}

export function isActive(s, t) {
  return t >= s.time && t <= s.time + (s.duration || ANNOTATION_WINDOW);
}
